import theme from '@css/theme.style.json';

const layers = [
  {
    id: 'vehicles-clusters',
    type: 'symbol',
    source: 'vehicles',
    filter: ['has', 'point_count'],
    layout: {
      'icon-image': 'sdf-cluster',
      'icon-size': [
        'step',
        ['get', 'total_capacity'],
        0.67, // Default size for clusters with fewer points
        100,  
        0.75, // Size for clusters with 100+ points
        200, 
        0.825, // Size for clusters with 200+ points
      ],
      'icon-allow-overlap': true,
      'text-field': [
        'case',
        ['>=', ['get', 'total_capacity'], 1000],
        ['concat', ['to-string', ['round', ['/', ['get', 'total_capacity'], 1000]]], 'k'],
        ['to-string', ['get', 'total_capacity']],
      ],
      'text-size': 15,
      'text-allow-overlap': true,
    },
    paint: {
      'icon-color': [
        'case',
        ['==', ['get', 'total_bicycle'], ['get', 'point_count']],
        theme.color.green.secondary,
        ['==', ['get', 'total_cargo_bicycle'], ['get', 'point_count']],
        theme.color.red.primary,
        ['==', ['get', 'total_car'], ['get', 'point_count']],
        theme.color.purple.primary,
        ['==', ['get', 'total_scooter'], ['get', 'point_count']],
        theme.color.blue.primary,
        ['==', ['get', 'total_moped'], ['get', 'point_count']],
        theme.color.pink.secondary,
        '#666',
      ],
      'icon-halo-color': [
        'case',
        ['==', ['get', 'total_bicycle'], ['get', 'point_count']],
        theme.color.green.secondary,
        ['==', ['get', 'total_cargo_bicycle'], ['get', 'point_count']],
        theme.color.red.primary,
        ['==', ['get', 'total_car'], ['get', 'point_count']],
        theme.color.purple.primary,
        ['==', ['get', 'total_scooter'], ['get', 'point_count']],
        theme.color.blue.primary,
        ['==', ['get', 'total_moped'], ['get', 'point_count']],
        theme.color.pink.secondary,
        '#666',
      ],
      'icon-halo-width': 1.5,
      'icon-halo-blur': 1.5,
      'text-color': theme.color.white,
    },
  },
  {
    id: 'vehicles',
    type: 'symbol',
    source: 'vehicles',
    filter: ['!', ['has', 'point_count']],
    layout: {
      'icon-image': 'sdf-marker',
      'icon-anchor': 'bottom',
      'icon-allow-overlap': true,
    },
    paint: {
      'icon-color': [
        'match',
        ['get', 'form_factor', ['get', 'vehicleType']],
        'bicycle', theme.color.green.secondary,
        'cargo_bicycle', theme.color.red.primary,
        'car', theme.color.purple.primary,
        'scooter', theme.color.blue.primary,
        'moped', theme.color.pink.secondary,
        '#666',
      ],
      'icon-halo-color': [
        'match',
        ['get', 'form_factor', ['get', 'vehicleType']],
        'bicycle', theme.color.green.secondary,
        'cargo_bicycle', theme.color.red.primary,
        'car', theme.color.purple.primary,
        'scooter', theme.color.blue.primary,
        'moped', theme.color.pink.secondary,
        '#666',
      ],
      'icon-halo-width': 1.5,
      'icon-halo-blur': 1.5,
    },
  },
  {
    id: 'vehicles-providers',
    type: 'symbol',
    source: 'vehicles',
    filter: ['!', ['has', 'point_count']],
    layout: {
      'icon-image': ['concat', ['get', 'operator'], '-2x'],
      'icon-anchor': 'bottom',
      'icon-allow-overlap': true,
      'icon-size': 0.5,
    },
  },
  {
    id: 'station-counter',
    type: 'symbol',
    source: 'vehicles',
    filter: ['has', 'marker_counter'],
    layout: {
      'icon-image': 'counter',
      'icon-size': 0.49,
      'icon-allow-overlap': true,
      'icon-anchor': 'bottom',
      'icon-offset': [2, 8],
      'text-field': ['get', 'marker_counter'],
      'text-anchor': 'bottom',
      'text-size': 10,
      'text-allow-overlap': true,
      'text-offset': [1.1, -2.7],
    },
    paint: {
      'icon-color': theme.color.yellow.primary,
      'text-color': theme.color.black,
    },
  },
  {
    id: 'vehicles-spiderfy-helper1',
    type: 'symbol',
    source: 'vehicles',
    filter: ['has', 'point_count'],
    layout: {
      'icon-image': 'sdf-cluster',
      'icon-size': ['step', ['get', 'point_count'], 0.67, 100, 0.75, 200, 0.825],
      'icon-allow-overlap': true,
    },
    paint: {
      'icon-halo-width': 1.5,
      'icon-opacity': 0,
    },
  },
  {
    id: 'vehicles-spiderfy-helper2',
    type: 'symbol',
    source: 'vehicles',
    filter: ['has', 'point_count'],
    layout: {
      'icon-image': 'sdf-cluster',
      'icon-size': ['step', ['get', 'point_count'], 0.67, 100, 0.75, 200, 0.825],
      'icon-allow-overlap': true,
    },
    paint: {
      'icon-halo-width': 1.5,
      'icon-opacity': 0,
    },
  },
]

export default layers;